// React
import React, { createContext, useContext, useEffect, useState } from "react";

// Third party imports
import { useDispatch } from "react-redux";

// API
import {
  setLatestNotifications,
  setNotificationsUnreadCount,
} from "redux/slices/notificationsSlice";
// Redux
import { setError } from "redux/slices/snackbarSlice";

// APIs
import { listLatestNotifications } from "api/notifications.jsx";

// Utils
import { isClientUser } from "utils/auth.jsx";

/**
 * NotificationsProvider fetches notifications from the API every 1 minute and
 * provides them to its children. It also handles loading state and errors.
 */
const NotificationsContext = createContext();
export const useNotifications = () => useContext(NotificationsContext);
export const NotificationsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchNotifications = async () => {
    try {
      const res = await listLatestNotifications();
      const notifications = res.data.notifications;
      setNotifications(notifications);
      dispatch(setLatestNotifications(notifications));
      dispatch(setNotificationsUnreadCount(res.data.count));
      setLoading(false);
    } catch (error) {
      dispatch(setError(error));
      setLoading(false);
    }
  };
  useEffect(() => {
    // Client (CU) users have no access to notifications: a 403 here would log them out
    if (localStorage.getItem("access") && !isClientUser()) {
      fetchNotifications();
      const intervalId = setInterval(fetchNotifications, 60000);
      return () => clearInterval(intervalId);
    }
  }, [dispatch]);
  return (
    <NotificationsContext.Provider value={{ notifications, fetchNotifications, loading }}>
      {children}
    </NotificationsContext.Provider>
  );
};
